// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_YKktV","detail":"index_detail_xe1Av","detailText":"index_detailText_wsOAj","detailIcon":"index_detailIcon_pi4WQ"};